// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__CSaP5","search":"Settings_search__1Pyh-","filter":"Settings_filter__2wO71"};